/**
 * A 403 can be either a stale session/CSRF rejection from the app or a security
 * block from the load balancer (AWS WAF/ALB). ALB-generated 403s carry
 * `Server: awselb/*`, whereas app-proxied 403s do not — use that to mark only
 * genuine WAF blocks so callers can show a security-block message instead of a
 * session-expired one.
 */
export function isAlbWafBlock(response: { status: number; headers?: { get(name: string): string | null } | null } | null | undefined): boolean {
    if (!response || response.status !== 403) {
        return false;
    }
    return (response.headers?.get("server") ?? "").toLowerCase().includes("awselb");
}

/**
 * Marker used on Error.cause to flag an ALB/WAF-blocked request, so UI layers
 * can show a security-block message instead of a generic/session-expired one.
 */
export const WAF_ERROR_CAUSE = "WAF";

export function getWafErrorMessage(feedbackMailto: string): string {
    return `Your message was blocked by our security system. Please [contact support](${feedbackMailto}) if you believe this is an error.`;
}
